export interface FloorNode {
  path: string;
  name: string;
  tier: number;
}

export const MAX_TIER = 3;

export const FLOOR_POOL: FloorNode[] = [
  { path: "floor_auth", name: "Legacy Auth Service", tier: 1 },
  { path: "floor_legacy", name: "The CSS Monolith", tier: 1 },
  { path: "floor_tests", name: "The Heisenbug", tier: 1 },
  { path: "floor_database", name: "The DELETE Without WHERE", tier: 2 },
  { path: "floor_production", name: "The On-Call Incident", tier: 2 },
  { path: "floor_merge", name: "The Merge Request Tribunal", tier: 2 },
  { path: "boss_senior", name: "The Senior Dev", tier: 3 },
];

export function tierForDepth(floorNumber: number): number {
  if (floorNumber <= 3) return 1;
  if (floorNumber <= 6) return 2;
  return 3;
}

export function isBossTier(floorNumber: number): boolean {
  return tierForDepth(floorNumber) === MAX_TIER;
}
